export function getInitials(name?: string) {
  if (!name) return ''
  // Split the name into 2 parts
  const [firstName, lastName] = name.split(' ')
  if (!lastName) return firstName.charAt(0)

  return firstName.charAt(0) + lastName.charAt(0)
}
